import { NgModule } from '@angular/core';
import { GatewayAngularSharedLibsModule } from './shared-libs.module';
import { FindLanguageFromKeyPipe } from './language/find-language-from-key.pipe';
import { AlertComponent } from './alert/alert.component';
import { AlertErrorComponent } from './alert/alert-error.component';
import { LoginModalComponent } from './login/login.component';
import { HasAnyAuthorityDirective } from './auth/has-any-authority.directive';
import { GeneralConditionComponent } from './general-condition/general-condition.component';
import { SafeHtmlPipe } from './general-condition/safe-html.pipe';

@NgModule({
  imports: [GatewayAngularSharedLibsModule],
  declarations: [FindLanguageFromKeyPipe, AlertComponent, AlertErrorComponent, LoginModalComponent, HasAnyAuthorityDirective, GeneralConditionComponent, SafeHtmlPipe],
  entryComponents: [LoginModalComponent],
  exports: [
    GatewayAngularSharedLibsModule,
    FindLanguageFromKeyPipe,
    AlertComponent,
    AlertErrorComponent,
    LoginModalComponent,
    HasAnyAuthorityDirective,
  ],
})
export class GatewayAngularSharedModule {}
